
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { LiaShoppingBagSolid } from "react-icons/lia";
import { FaCreditCard, FaLock, FaShieldAlt } from "react-icons/fa";
import { useLocation, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ApiService from "../services/ApiService";
import PageLoader from "../components/PageLoader";
import cardImg from "../assets/images/card-acccepted.png";
import Header from "../components/Header";

const AddCard = () => {
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(window.location.search);
  const goto = searchParams.get('goto') || '/checkout';
  console.log(goto);
  
  const [pageLoader, setPageLoader] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
    const [formData, setFormData] = useState([]);
    const [saveForFuture, setSaveForFuture] = useState(true);
    const [paymentMethods, setPaymentMethods] = useState({
      applePay: true,
      googlePay: true
    });
    const [paymentMode, setPaymentMode] = useState('test');
  const [savedCards, setSavedCards] = useState([]);
  const [showCardList, setShowCardList] = useState(false);
  const [selectedCard, setSelectedCard] = useState('');
  
  // Use ref to track if Frames has been initialized
  const framesInitialized = useRef(false);
  // Use ref to track if event handlers have been registered
  const eventHandlersRegistered = useRef(false);

  // Initialize saveForFuture from localStorage
  useEffect(() => {
    const savedPreference = localStorage.getItem('save_for_future');
    if (savedPreference !== null) {
      setSaveForFuture(savedPreference === 'true');
    }
    getSettings();
  }, []);

  
  const getSettings = async () => {
    try {
      setIsLoader(true);
      const response = await ApiService.request({
        method: "GET",
        url: "/getAppData",
      });
      const data = response.data;

      if (data.status) {
        console.log("data.data?.payment_mode", data.data?.payment_mode);
        setPaymentMode(data.data?.payment_mode);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setIsLoader(false);
    }
  };

  useEffect(() => {

    // Prevent multiple initializations
    // if (framesInitialized.current) {
    //   console.log("Frames already initialized, skipping...");
    //   return;
    // }

    if (typeof window.Frames === "undefined") {
      console.error("Frames.js not loaded!");
      return;
    }

    const initializePaymentMethods = async () => {
      try {
        const public_key = paymentMode === 'live' ? process.env.REACT_APP_CHECKOUT_KEY_LIVE : process.env.REACT_APP_CHECKOUT_KEY_TEST;
        console.log("paymentMode", paymentMode);
        // Initialize Frames
        window.Frames.init({
          publicKey: public_key,
          frameSelector: "#card-frame",
          localization: {
            cardNumberPlaceholder: "Card number",
            expiryMonthPlaceholder: "MM",
            expiryYearPlaceholder: "YY",
            cvvPlaceholder: "CVV"
          },
          style: {
            base: {
              color: "#333",
              fontSize: "16px"
            }
          }
        });

        // Register event handlers only once
        if (!eventHandlersRegistered.current) {
          window.Frames.addEventHandler("cardTokenized", (event) => {
            setIsLoader(true);
            console.log("Card Token:", event);
            handleSubmit(event.token);
          });
          
          eventHandlersRegistered.current = true;
          console.log("Event handlers registered");
        }

        framesInitialized.current = true;
        console.log("Frames initialized successfully.");
      } catch (error) {
        console.error("Error initializing payment methods:", error);
      }
    };
    
    initializePaymentMethods();
    
    const user = localStorage.getItem("user");
    
    // Cleanup function to remove event listeners
    return () => {
      if (typeof window.Frames !== "undefined" && eventHandlersRegistered.current) {
        // Note: Frames doesn't have a removeEventHandler method in all versions
        // This is a precautionary measure
        console.log("Component unmounted - consider cleanup if needed");
      }
    };
  }, [paymentMode]); // Empty dependency array means this runs once on mount

  const handlePayment = () => {
    if (!window.Frames.isCardValid()) {
      alert("Please enter valid card details.");
      return;
    }
    window.Frames.submitCard();
  };

  const processPayment = async (googlePayToken) => {
    try {
      const response = await ApiService.request({
        method: "POST",
        url: "process-google-pay", 
        data: {
          token: googlePayToken,
          amount: 10.00,
          currency: 'USD'
        }
      });
      const data = response.data;
     
      if (data.status) {
        alert("Payment successful!");
      } else {
        alert(`Payment failed: ${data.message}`);
      }
    } catch (error) {
      console.error('Error:', error);
      alert("Payment processing error");
    }
  };

  const getSavedCards = async () => {
    try {
      const response = await ApiService.request({
        method: "GET",
        url: "/getCustomerCards",
      });
      const data = response.data;
      
      if (data.status) {
        setSavedCards(data.data?.cards || []);
      }
    } catch (error) {
      console.error("Error fetching cards:", error);
    }
  };

  const handleCardSelection = (cardId) => {
    setSelectedCard(cardId);
    localStorage.setItem('selected_card_id', cardId);
  };

  const proceedToCheckout = () => {
    if (selectedCard) {
      navigate('/checkout');
    } else {
      toast.error("Please select a card to proceed");
    }
  };

  const addNewCard = () => {
    setShowCardList(false);
    setSelectedCard('');
  };

  const handleSubmit = async (cardToken) => {
    try {
      // Prevent multiple submissions
      if (isLoader) {
        console.log("Submission already in progress");
        return;
      }
      setIsLoader(true);
      const saveForFuture=localStorage.getItem('save_for_future');
      if(saveForFuture !== "false"){
        localStorage.setItem('save_for_future', "true");
      }
      const response = await ApiService.request({
        method: "POST",
        url: "/addCard",
        data: { 
          cardToken,
          amount: 0 // Don't charge payment immediately
        }
      });
      const data = response.data;
      
      if (data.status) {
        // Store card ID and save preference in localStorage
        const cardId = data.data?.instrumentId || data.data?.cardId;
        localStorage.setItem('selected_card_id', cardId);
        
        if (data.data?.cardExists) {
          toast.success("Card already exists!");
        } else if (data.data?.oneTimeUse) {
          toast.success("Card ready for payment!");
        } else {
          toast.success("Card saved successfully!");
        }
        // Fetch and show saved cards instead of navigating to checkout
        // await getSavedCards();
        // setShowCardList(true);
      } else {
        toast.error(data.message);
      }
      navigate(`${goto}`);

      
    } catch (error) {
      console.error("API Error:", error.message);
      console.error(error);
      toast.error("Failed to add card. Please try again.");
    } finally {
      setIsLoader(false);
    }
  };

  return (
    <>
      {pageLoader ? (
        <PageLoader />
      ) : (
        <div className="main-heading items-details-main container">
          {/* Header Section */}
          <Header title={'Add Payment Method'} back={goto}/>


          {/* Main Content */}
          <div className="container-fluid px-4">
            <div className="row">
              <div className="col-md-6 mt-5">
                {/* Security Notice */}
                <div className="security-notice bg-light border rounded-3 p-4 mb-4">
                  <div className="d-flex align-items-center mb-3">
                    <FaShieldAlt className="text-success me-2 fs-4" />
                    <h6 className="mb-0 fw-bold text-success">Secure Payment</h6>
                  </div>
                  <p className="mb-0 text-muted small">
                    Your payment information is encrypted and secure. We use industry-standard SSL encryption to protect your data.
                  </p>
                </div>

              </div>

              <div className="col-md-6">
                {showCardList ? (
                  /* Saved Cards List */
                  <div className="saved-cards-section">
                    <div className="d-flex align-items-center mb-3">
                      <FaCreditCard className="text-primary me-2 fs-4" />
                      <h5 className="mb-0 fw-bold">Select Payment Method</h5>
                    </div>
                    
                    <div className="card-list mb-4">
                      {savedCards.length > 0 ? (
                        savedCards.map((card, index) => (
                          <div 
                            key={card.id || index}
                            className={`card-item border rounded-3 p-3 mb-3 cursor-pointer ${
                              selectedCard === card.id ? 'border-primary bg-light' : 'border-secondary'
                            }`}
                            onClick={() => handleCardSelection(card.id)}
                            style={{ cursor: 'pointer' }}
                          >
                            <div className="d-flex align-items-center justify-content-between">
                              <div>
                                <div className="d-flex align-items-center">
                                  <input 
                                    type="radio" 
                                    name="selectedCard" 
                                    checked={selectedCard === card.id}
                                    onChange={() => handleCardSelection(card.id)}
                                    className="me-3"
                                  />
                                  <div>
                                    <h6 className="mb-1">
                                      {card.scheme?.toUpperCase()} •••• {card.last4}
                                    </h6>
                                    <small className="text-muted">
                                      Expires {card.expiry_month}/{card.expiry_year}
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <div className="text-end">
                                <small className="text-muted">Default</small>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-center py-4">
                          <p className="text-muted">No saved cards found</p>
                        </div>
                      )}
                    </div>

                    <div className="d-flex gap-2 mb-3">
                      <button 
                        type="button" 
                        onClick={proceedToCheckout}
                        disabled={!selectedCard}
                        className="btn btn-base flex-fill py-3 fw-bold rounded-3"
                      >
                        <FaLock className="me-2" />
                        Proceed to Checkout
                      </button>
                    </div>

                    <div className="text-center">
                      <button 
                        type="button" 
                        onClick={addNewCard}
                        className="btn btn-outline-primary"
                      >
                        Add New Card
                      </button>
                    </div>
                  </div>
                ) : (
                  /* Card Form Section */
                  <div className="card-form-section">
                  <div className="d-flex align-items-center mb-3">
                    <FaCreditCard className="text-primary me-2 fs-4" />
                    <h5 className="mb-0 fw-bold">Credit/Debit Card Details</h5>
                  </div>
                  
                  <div className="card-input-container border rounded-3 p-3 mb-4">
                    <div id="card-frame" className="w-100"></div>
                  </div>

                  {/* Save for Future Checkbox */}
                  <div className="form-check mb-4">
                    <input 
                      className="form-check-input" 
                      type="checkbox" 
                      id="saveForFuture"
                      checked={saveForFuture}
                      onChange={(e) => { setSaveForFuture(e.target.checked); localStorage.setItem('save_for_future', e.target.checked)}}
                    />
                    <label className="form-check-label" htmlFor="saveForFuture">
                      <strong>Save this card for future payments</strong>
                      <small className="d-block text-muted">Your card will be securely stored for faster checkout next time</small>
                    </label>
                  </div>

                                     {/* Payment Button */}
                   <button 
                     type="button" 
                     onClick={handlePayment} 
                     disabled={isLoader}
                     className="btn btn-base w-100 py-3 fw-bold fs-5 rounded-3 shadow-sm"
                   >
                     {isLoader ? (
                       <>
                         <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                         Processing...
                       </>
                     ) : (
                                               <>
                          <FaLock className="me-2" />
                          Continue to Checkout
                        </>
                     )}
                   </button>

                  {/* Additional Info */}
                  <div className="text-center mt-4">
                    <p className="text-muted small mb-2">
                      By adding a card, you agree to our terms of service
                    </p>
                    <div className="d-flex justify-content-center align-items-center gap-3">
                      <img src={cardImg} alt="cards" style={{width: '200px', height: 'auto'}} />
                    </div>
                  </div>
                </div>
                )}
              </div>
            </div>

          </div>
        </div>
      )}
    </>
  );
};

export default AddCard;
